
import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"

import { thousandSeparator } from "utils"
import { CurrencyInput } from "components"
import classes from "./OfflineOrderDetailCancelModalHeader.module.scss"

const OfflineOrderDetailCancelModalHeader = props => {
  const { amount, total, orderStatus } = props

  const [t] = useTranslation()

  return (
    <Fragment>
      <div className={classes["title"]}>
        {t("آیا_می_خواهید_این_سفارش_را_لغو_کنید")}
      </div>

      {
        orderStatus === "paid" &&
        <div className={classes["remarks"]}>
          <div className={classes["textRemark"]}>
            <span className={classes["text"]}>
              توجه مقدار
            </span>
            <span className={classes["bold"]}>
              {" "}{thousandSeparator(total)}{" "}
            </span>
            <span className={classes["text"]}>
              {" "}نیاز هست که به صورت {" "}
            </span>
            <span className={classes["bold"]}>
              {" "}نقد{" "}
            </span>
            <span className={classes["text"]}>
              به مشتری پرداخت شود
            </span>
          </div>

          <div className={classes["input"]}>
            <CurrencyInput
              readOnly
              label={t("مقدار")}
              value={amount}
            />
          </div>
        </div>
      }
    </Fragment >
  )
}

export default OfflineOrderDetailCancelModalHeader